var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gitlabTitle"
  }, "GitLab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "gitlabTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "#1f1e24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 58l12-36h10l14 40 14-40h10l12 36-36 40z",
    fill: "#fc6d26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 58l20 0 16 40z",
    fill: "#e24329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58l-20 0-16 40z",
    fill: "#fca326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.a4c91df1da1a46a275f8d951853dc567.svg";
export { ForwardRef as ReactComponent };